import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.login(email, password);
      setAuth(data.user, data.token);
      toast.success(`Welcome back, ${data.user.full_name}!`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Background glow */}
      <div style={{
        position: 'absolute', width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(79,142,247,.08) 0%, transparent 70%)',
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
      }} />

      <div style={{ width: '100%', maxWidth: 400, position: 'relative' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14, margin: '0 auto 16px',
            background: 'linear-gradient(135deg, var(--accent) 0%, #6BA8FF 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, boxShadow: '0 8px 24px rgba(79,142,247,.3)',
          }}>◈</div>
          <div style={{ fontFamily: "'Bebas Neue', serif", fontSize: 28, fontWeight: 600, letterSpacing: '-.5px' }}>Mich-CA Portal</div>
          <div style={{ fontSize: 13, color: 'var(--mid)', marginTop: 6 }}>2026 Season · Michigan Cricket Association</div>
        </div>

        <div className="card" style={{ padding: '28px 30px', borderColor: 'var(--border-light)' }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 22, color: 'var(--text-2)' }}>Sign in to continue</div>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label">Email Address</label>
              <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com" required autoFocus />
            </div>
            <div className="field" style={{ marginBottom: 24 }}>
              <label className="field-label">Password</label>
              <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}
              style={{ width: '100%', justifyContent: 'center', padding: '11px', fontSize: 14 }}>
              {loading ? '⟳ Signing in...' : 'Sign In →'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--dim)', marginTop: 20 }}>
          Need access? Contact your MichCA administrator.
        </p>
      </div>
    </div>
  );
}
